import { render, staticRenderFns } from "./v-footerBottom.vue?vue&type=template&id=00119db2&"
import script from "./v-footerBottom.vue?vue&type=script&lang=js&"
export * from "./v-footerBottom.vue?vue&type=script&lang=js&"
import style0 from "./v-footerBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports